/* eslint-disable */
export default {
  ringtones: '鈴聲',
  incomingRingtone: '來電鈴聲',
  outgoingRingtone: '去電鈴聲',
  play: '播放',
  stop: '停止',
  upload: '上傳',
  reset: '重設',
  save: '儲存',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
